import Axios from 'axios'
import CodeData from "../../model/clases/CodeData";

export class VerifyCodeAPI {
  url: string = "https://prodaja.lo.co.me/putnotest/api/checkVerificationCode.php";

  verify(data: CodeData): Promise<any> {
    return Axios.post(`${this.url}`, data);
  }
}
